import resourceService from './resource_service';

const modelName = 'app-permission';

const attributes = {
  uses: '',
};

const relationships = {
  app: {
    jsonApi: 'hasOne',
  },
  plantUser: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
